/* global localData */
if (document.querySelector('.sc-quiz-module')) {
  let points = 0;
  const lastButton = document.querySelector('.quiz-result__last_button a');
  const allSteps = document.querySelectorAll('.quiz-module__item.question-item');
  const allButtons = document.querySelectorAll('.quiz-screen__next-btn, .btn--default');
  const allRadios = document.querySelectorAll('input[type="radio"]');
  const removeIsActiveClass = () => {
    document.querySelectorAll('.quiz-module__item').forEach((step) => {
      step.classList.remove('is-active');
    });
  }
  const goToNextStep = (step) => {
    removeIsActiveClass();
    allSteps[step].classList.add('is-active');
    if (allSteps[step].querySelector('.is-active .quiz-result__total')) {
      let resultsText = '';
      const result = (points/(allSteps.length-1) * 100).toFixed(0);
      if (localData.translations.results) {
        localData.translations.results.forEach((item) => {
          if (item.number <= result) {
            resultsText = item.text;
          }
        });
      }
      document.querySelector('.quiz-result__total').innerHTML = `${result} ${localData.translations.points}`;
      document.querySelector('.quiz-result__indicator-progress').style.width = `${result}%`;
      document.querySelector('.quiz-result__text p').innerHTML = resultsText;
      points = 0;
    }
  }
  lastButton.addEventListener('click', (ev) => {
    ev.preventDefault();
    ev.stopPropagation();
    document.querySelector('.menu__sub-items .level-2 span').click();
  });
  allRadios.forEach((radio) => {
    radio.addEventListener('click', (ev) => {
      const currentActive = document.querySelector('.quiz-module__item.is-active').dataset.index;
      removeIsActiveClass();
      ev.preventDefault();
      document.querySelector(`${(Number(ev.target.value) === 1) ? '.is-correct' : '.is-false'}[data-index=${currentActive}]`).classList.add('is-active');
      if (Number(ev.target.value) === 1) {
        points +=1;
      }
    });
  });
  allButtons.forEach((btn) => {
    btn.addEventListener('click', (ev) => {
      if (ev.target.closest('a, button').dataset.step) {
        ev.preventDefault();
        ev.stopPropagation();
        goToNextStep(ev.target.closest('a, button').dataset.step);
      }
    });
  });
}
